import React, { Fragment, useState } from "react";
import PageHead from "../../components/pageHead";
// import { checkScrollDirection } from "../../utils/menuNav";
import MobileNav from "../../components/mobileNav";
import useMediaQuery from "../../hooks/useMediaQuery";
import ProfileForm from "./profileForm";
import PromptForm from "./promptForm";
import styles from "./style.module.css";

const Profile = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [isScrolling] = useState(false);

  const handleScroll = (e) => {
    // const scrollDirection = checkScrollDirection(e);
    // setIsScrolling(scrollDirection);
  };

  return (
    <Fragment>
      <PageHead logo={isMobile} title="Profile" />
      <div className={styles.body} onScroll={handleScroll}>
        <ProfileForm />
        <PromptForm />
      </div>
      {isMobile && <MobileNav defaultActive={true} isScrolling={isScrolling} />}
    </Fragment>
  );
};

export default Profile;
